import React from 'react'
import {Provider} from 'react-redux'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import 'react-datepicker/dist/react-datepicker.css'

import '../../shared_styles/styles.css'
import '../../shared_client_utils/initializeLocaleForMomentAndDatepicker'
import theme from '../../shared_client_utils/theme'
import {store} from './store'
import BookPage from './BookPage'

const urlParams = new URLSearchParams(window.location.search);
const query = Object.fromEntries(urlParams)

export const Root = () => {
  // Some of components here is reused in Edit Appointment page that uses Next.js framework
  // Here we pass simulated router props that is used in some of components
  const router = {
    query: {...query, slug: window.businessSlug},
    reload() {
      window.location.reload()
    }
  }
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <BookPage router={router} />
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
